import { connect, ConnectedProps } from 'react-redux';
import { fetchCards } from '../../actions/fetchCards';
import { fetchDemoCards } from '../../actions/fetchDemoCards';
import { fetchFreeText } from '../../actions/fetchFreeText';
import { setDemoViewMode } from '../../actions/setDemoViewMode';
import { setDeviceType } from '../../actions/setDeviceType';
import { setFreeText } from '../../actions/setFreeText';
import { setLocale } from '../../actions/setLocale';
import { fetchRecurringPaymentMethods } from '../../actions/fetchRecurringPaymentMethods';
import { selectAppLoaded, selectViewMode } from '../../selectors/appState';
import { selectCardList } from '../../selectors/creditCard';
import { IStoreState } from '../../types/StoreState';
import { setAppSessionId } from '../../actions/setAppSessionId';

export const connector = connect(
  (state: IStoreState) => ({
    isAppLoaded: selectAppLoaded(state),
    cardsLength: selectCardList(state).length,
    viewMode: selectViewMode(state),
  }),
  {
    fetchCards,
    fetchFreeText,
    fetchDemoCards,
    fetchRecurringPaymentMethods,
    setFreeText,
    setDeviceType,
    setLocale,
    setDemoViewMode,
    setAppSessionId,
  },
);

export type AppControllerPropsFromRedux = ConnectedProps<typeof connector>;
